import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../Context/AuthContext';
const { TITLE } = require('../../MetaData/Metadata');


const NavBar = () => {
    const { isAuthenticated } = useContext(AuthContext);

    return (
        <div className="mb-3">
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                {/* <Link className="navbar-brand" to="#">{TITLE}</Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button> */}
                <Link className="navbar-brand" to="/">
                    <img src={'/Assets/logo.png'} width="60px" height="80px" className="d-inline-block mr-2" alt="" />
                    {TITLE}
                </Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                    <div className="navbar-nav">
                        <Link to='/' className="nav-item nav-link">Home</Link>
                        {isAuthenticated ?
                            <Link to='/logout' className="nav-item nav-link">Logout</Link> :
                            <Link to='/login' className="nav-item nav-link">Login</Link>
                        }
                    </div>
                </div>
            </nav>
        </div>
    );
}

export default NavBar;